import { Avatar, Message } from "@chatscope/chat-ui-kit-react";
import React from "react";
import { MessageDirection } from "../useChat";
import { replaceUrlFromMessageContent } from "../utils/chat";
import { convertToJapanTime } from "../utils/helpers";
export const CustomTextMessage = ({ message, direction, isFirstMessage = false, user }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    return /*#__PURE__*/ React.createElement(Message, {
        model: {
            type: "html",
            payload: message.content,
            direction: "incoming",
            position: "normal"
        }
    }, direction === MessageDirection.Incoming && /*#__PURE__*/ React.createElement(Message.Header, {
        "data-cs-first-message": isFirstMessage
    }, /*#__PURE__*/ React.createElement(Avatar, {
        src: ((_a = user === null || user === void 0 ? void 0 : user.profile) === null || _a === void 0 ? void 0 : _a.url_1) || ((_b = user === null || user === void 0 ? void 0 : user.profile) === null || _b === void 0 ? void 0 : _b.url_2) || ((_c = user === null || user === void 0 ? void 0 : user.profile) === null || _c === void 0 ? void 0 : _c.url_3)
    }, /*#__PURE__*/ React.createElement("img", {
        src: ((_d = user === null || user === void 0 ? void 0 : user.profile) === null || _d === void 0 ? void 0 : _d.url_1) || ((_e = user === null || user === void 0 ? void 0 : user.profile) === null || _e === void 0 ? void 0 : _e.url_2) || ((_f = user === null || user === void 0 ? void 0 : user.profile) === null || _f === void 0 ? void 0 : _f.url_3),
        alt: `user_img_${user === null || user === void 0 ? void 0 : user.id}`,
        onError: e => {
            e.target.src = "/images/fallback/default.png";
        }
    }))), /*#__PURE__*/ React.createElement(Message.HtmlContent, {
        html: replaceUrlFromMessageContent((_g = message.content) !== null && _g !== void 0 ? _g : "")
    }), /*#__PURE__*/ React.createElement(Message.Footer, {
        sentTime: convertToJapanTime(message.createdTime)
    }));
};
